import { useStore } from '@/hooks/useStore';
import { useLocation, useNavigate } from 'react-router-dom';
import { observer } from 'mobx-react-lite';
import { useCallback, useEffect, useState } from 'react';
import { Button } from '@/components/common/Button';
import { t } from 'i18next';
import { useTranslation } from 'react-i18next';
import { ROUTES } from '@/configs/constants';
import { toastify } from '@/utils/toastify';
import Header from '@/components/layout/Header';
import CardList from '@/components/common/CardList';
import { Item, OwnerItem } from '@/types/item';
import mapPinIcon from '@/assets/images/pngs/MapPin.png';
import { flowResult } from 'mobx';
import { PagingRequest } from '@/types/http';
import { getParamsLoadMore } from '@/utils/utils';

export default observer(function ListItems() {
    // store
    const {
        itemsStore: { getListItems, listItems, total },
        apiStore: { isLoading }
    } = useStore();
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [listSelecting, setListSelecting] = useState<OwnerItem[]>([]);
    const defauleParams: PagingRequest = {
        page: 1,
        size: 10
    };
    const [params, setParams] = useState<PagingRequest>(defauleParams);
    useEffect(() => {
        getListItems(defauleParams);
        setListSelecting([]);
    }, []);
    const handleChangeSelect = useCallback((list) => {
        const data: OwnerItem[] = list
            .map(el => listItems.find(e => e.id === el));
        setListSelecting(prev => [...data]);
    }, [listItems]);

    useEffect(() => {
        console.log(listSelecting);
    }, [listSelecting]);

    const goBack = () => {
        navigate(ROUTES.home.href);
    };

    const handleSetting = () => {
        navigate(ROUTES.setLocationItem.href, { state: { items: JSON.stringify(listSelecting) } });
    };
    const onLoadMore = async () => {
        if (params.size >= total) return;
        const newParams = getParamsLoadMore(params, total);
        if (!newParams) return;
        return await flowResult(getListItems(newParams));
    };

    return (
        <div className='w-screen h-screen flex flex-col justify-start pt-[72px]'>
            <Header title={t('text.listItems')} goBackFunction={goBack} />
            <div className='h-[calc(100vh-72px-32px)] bg-bgMain flex flex-col justify-between content-center px-[16px]'>
                <CardList
                    onChangeSelect={handleChangeSelect}
                    items={listItems}
                    className='w-full h-full py-[12px] gap-[12px] bg-bgMain overflow-y-scroll scrollbar-hide'
                    onEndReached={async () => {
                        onLoadMore();
                    }}
                    isLoading={isLoading}
                />
                <div className='h-[72px] w-full  flex justify-between items-center space-x-[10px]'>
                    <Button
                        variant='white'
                        className=' w-full h-[48px] rounded-[10px]'
                        onClick={goBack}
                    >
                        {t('text.cancel')}
                    </Button>
                    <Button
                        variant='main'
                        className=' w-full h-[48px] rounded-[10px]'
                        onClick={handleSetting}
                        disabled={listSelecting.length <= 0}
                    >
                        <img src={mapPinIcon} alt={mapPinIcon} className='w-4 h-4 mr-1' />
                        {t('text.setting')}
                    </Button>
                </div>
            </div>

        </div>
    );
});
